module.exports = __webpack_public_path__ + "assets/959935dc8a3df2388c46061cb3857f79.png";